import { Printer } from './../model/printer';
export class PrinterBuilder {
    static buildPrinter(data) {
        let printer = new Printer();
        printer.id = data.id;
        printer.id_paydesk = data.id_paydesk;
        printer.name = data.name;
        printer.ip = data.ip;
        printer.port = data.port;
        printer.active = data.active;
        return printer;
    }
}
//# sourceMappingURL=printer-builder.js.map